export default __webpack_public_path__ + "be5cd43c5ff9cd6ad7e6a1856fde3ef8.png";